@if(service.viewDroplistItems.length){
<div class='configuration-accelerators-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.ProgramFacilitators) {
	<configuration-accelerators-program-facilitators-view-part></configuration-accelerators-program-facilitators-view-part>
	}
	@case (service.viewId.Accelerators) {
	<configuration-accelerators-accelerators-view-part></configuration-accelerators-accelerators-view-part>
	}
	}
	}

</div>
}